// @flow
import { getCreator } from '../../../http';
import environment from '../../../environment';

export const endpoints = Object.freeze({
  GET_PURCHASE: `${environment.apiUrl}/purchase/:id`,
});

export const getPurchaseApi = getCreator(fetch, endpoints.GET_PURCHASE);



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutSuccessStep/api.js